import { render, staticRenderFns } from "./FolderTree.vue?vue&type=template&id=4d3f82a5&scoped=true&"
import script from "./FolderTree.vue?vue&type=script&lang=js&"
export * from "./FolderTree.vue?vue&type=script&lang=js&"
import style0 from "./FolderTree.vue?vue&type=style&index=0&id=4d3f82a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f82a5",
  null
  
)

export default component.exports